"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCard = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const Stack_1 = require("../Stack");
const Text_1 = require("../Text");
const CreateCard = (_a) => {
    var { icon, title, label } = _a, props = __rest(_a, ["icon", "title", "label"]);
    return (react_1.default.createElement(Stack_1.Stack, Object.assign({ as: "button", css: {
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            height: '100%',
            padding: '24px',
            fontFamily: 'inherit',
            flex: 1,
            justifyContent: 'space-between',
            border: '1px solid',
            borderColor: 'transparent',
            borderRadius: '4px',
            backgroundColor: '#1D1D1D',
            outline: 'none',
            textDecoration: 'none',
            transition: 'background ease-in-out',
            transitionDuration: theme => theme.speeds[2],
            ':hover': {
                backgroundColor: '#252525',
            },
            ':focus-visible': {
                borderColor: 'focusBorder',
            },
        }, direction: "vertical", justify: "space-between" }, props),
        react_1.default.createElement(Icon_1.Icon, { color: "#999999", name: icon, size: 20 }),
        react_1.default.createElement(Stack_1.Stack, { css: { width: '100%' }, direction: "vertical", gap: 1 },
            label && label !== '' ? (react_1.default.createElement(Text_1.Text, { color: "#999", size: 12 }, label)) : null,
            react_1.default.createElement(Text_1.Text, { css: {
                    width: '100%',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                }, color: "#EBEBEB", lineHeight: "16px", size: 13, weight: "medium" }, title))));
};
exports.CreateCard = CreateCard;
